import type { DefaultEdgeTypes, DefaultNodeTypes } from '../types'

import DefaultNode from '../components/nodes/DefaultNode'
import OutputNode from '../components/nodes/InputNode'
import InputNode from '../components/nodes/OutputNode'
import BezierEdge from '../components/edge/BezierEdge'
import SmoothStepEdge from '../components/edge/SmoothStepEdge'
import SimpleBezierEdge from '../components/edge/SimpleBezierEdge'
import LoopbackBezierEdge from '../components/edge/LoopbackBezierEdge'

export const defaultNodeTypes: DefaultNodeTypes = {
  input: InputNode,
  default: DefaultNode,
  output: OutputNode,
}

export const defaultEdgeTypes: DefaultEdgeTypes = {
  default: BezierEdge,
  smoothstep: SmoothStepEdge,
  simplebezier: SimpleBezierEdge,
  loopback: LoopbackBezierEdge
}
